var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnterprise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.96 165.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2c75fb;}.cls-3{fill:#7da2fe;stroke-linejoin:round;stroke-width:2px;}.cls-3,.cls-4,.cls-5{stroke:#fff;}.cls-3,.cls-5{stroke-linecap:round;}.cls-4{fill:rgba(255,255,255,.2);}.cls-4,.cls-5{stroke-miterlimit:10;}.cls-5{fill:none;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "61.49 161.86 .5 161.86 .5 65.87 61.49 36.65 61.49 161.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 8.48,
    y1: 73.27,
    x2: 53.5,
    y2: 73.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 81.95,
    x2: 8.48,
    y2: 81.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 90.63,
    x2: 8.48,
    y2: 90.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 99.3,
    x2: 8.48,
    y2: 99.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 107.98,
    x2: 8.48,
    y2: 107.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 116.66,
    x2: 8.48,
    y2: 116.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 125.34,
    x2: 8.48,
    y2: 125.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 134.02,
    x2: 8.48,
    y2: 134.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 142.7,
    x2: 8.48,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.5,
    y1: 151.38,
    x2: 8.48,
    y2: 151.38
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 91.98,
    y: 1,
    width: 60.99,
    height: 160.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 9.31,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 28.78,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 48.24,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 67.71,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 87.17,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 106.63,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 126.1,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.15,
    y: 145.56,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 9.31,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 28.78,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 48.24,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 67.71,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 87.17,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 106.63,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 126.1,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.14,
    y: 145.56,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 9.31,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 28.78,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 48.24,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 67.71,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 87.17,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 106.63,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 126.1,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.13,
    y: 145.56,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 9.31,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 28.78,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 48.24,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 67.71,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 87.17,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 106.63,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 126.1,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.13,
    y: 145.56,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 9.31,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 28.78,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 48.24,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 67.71,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 87.17,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 106.63,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 126.1,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.12,
    y: 145.56,
    width: 4.67,
    height: 8.58
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.31,
    y: 63.87,
    width: 64.99,
    height: 99.99,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.29,65.87v95.99H47.31V65.87h60.99m0-4H47.31c-2.21,0-4,1.79-4,4v95.99c0,2.21,1.79,4,4,4h60.99c2.21,0,4-1.79,4-4V65.87c0-2.21-1.79-4-4-4h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73,
    y: 70.36,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73,
    y: 89.54,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73,
    y: 108.73,
    width: 8.92,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.77,
    y: 70.36,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.77,
    y: 89.54,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.77,
    y: 108.73,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.77,
    y: 127.91,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.77,
    y: 147.09,
    width: 8.92,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.22,
    y: 70.36,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.22,
    y: 89.54,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.22,
    y: 108.73,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.22,
    y: 127.91,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.22,
    y: 147.09,
    width: 8.92,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.75,
    y: 130.49,
    width: 17.42,
    height: 33.22,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.17,132.48v29.22h-13.43v-29.22h13.43m0-4h-13.43c-2.21,0-4,1.79-4,4v29.22c0,2.21,1.79,4,4,4h13.43c2.21,0,4-1.79,4-4v-29.22c0-2.21-1.79-4-4-4h0Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.63ea47dd4dd985edcd0c2b7584459357.svg";
export { ForwardRef as ReactComponent };